import { Card } from "@/components/ui/card"
import { TrialApplicationForm } from "@/components/TrialApplicationForm"

export function CTASection() {
  return (
    <section id="apply" className="py-20 bg-navy text-ivory">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/20 text-gold text-sm font-medium uppercase tracking-wider mb-6">
            ⚽ Start Your Football Journey
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold tracking-tight mb-6">
            Your football journey begins with discipline.
          </h2>
          <p className="text-xl text-ivory/70">
            Apply for football trials or register interest to become part of ZOE Football Academy.
          </p>
        </div>

        <Card className="p-8 sm:p-12 bg-navy-muted border border-ivory/10">
          <TrialApplicationForm formType="Homepage Application" dark />
        </Card>

        <div id="contact" className="mt-16 text-center">
          <p className="text-ivory/60 mb-4">
            For partnership inquiries or general questions:
          </p>
          <a
            href="mailto:admin@zoeventures.one"
            className="text-gold hover:text-gold/80 text-lg font-medium transition-colors"
          >
            admin@zoeventures.one
          </a>
        </div>
      </div>
    </section>
  )
}
